import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { TextInput, Dropdown, DropdownWithSearch, Image } from "hesus-ui-kit";
import {
  useGetGeneralParameters,
  useGetMultiUserCurrenciesByCountryId,
  useGetMainCurrencyByCountryId,
} from "@hooks/useGeneralParams";
import { updateUnitTranslation } from "@utils/utils";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import deleteIcon from "@icons/ic-delete-red.svg";
import {
  ContainerLabel,
  GridRow,
  CreateButton,
  FilterFlexRow,
} from "../../AddEditWarehouse.styled";
import "../../AddEditWarehouse.scss";

const Trucks = (props) => {
  const {
    t,
    inputList,
    setInputList,
    inputListError,
    setInputListError,
    isRequired,
    setIsRequired,
    countryId,
  } = props;

  const [transportTypes, setTransportTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const generalParams = useGetGeneralParameters();

  const { unitList } = generalParams;
  const mainCurrency = useGetMainCurrencyByCountryId(countryId);
  const multiUserCurrencies = useGetMultiUserCurrenciesByCountryId(countryId);

  useEffect(() => {
    const currenciesList = Object.entries(multiUserCurrencies).map((entry) => ({
      label: entry[1],
      value: parseInt(entry[0], 10),
    }));
    setCurrencies(currenciesList);
  }, []);

  useEffect(() => {
    if (!countryId) return;
    axios
      .get(
        `/transports?status=1&countries=${countryId}&orderBy=asc&limit=-1`,
        {}
      )
      .then((response) => {
        const responseData = response.data.transports.map((item) => {
          const tempData = {
            value: item.id,
            label: item.name,
          };
          return tempData;
        });
        setTransportTypes(responseData);
      })
      .catch((error) => {});
  }, [countryId]);

  const handleInputChange = (e, index, name, errorName) => {
    const list = [...inputList];
    const listError = [...inputListError];
    const listRequiredStatus = [...isRequired];
    const status = "requiredStatus";
    if (name === "unit" || name === "currency") {
      list[index][name] = e.value;
      listError[index][errorName] = "";
    }
    if (name === "price" || name === "count") {
      list[index][name] = e.target.value;
      listError[index][errorName] = "";
    }
    if (name === "transportType") {
      list[index][name] = e;
      listError[index][errorName] = "";
    }
    // if (list[index][name] === "") {
    //   listRequiredStatus[index][status] = true;
    // } else {
    //   listRequiredStatus[index][status] = false;
    // }
    // setIsRequired(listRequiredStatus);
    setInputList(list);
    setInputListError(listError);
  };

  useEffect(() => {
    const listRequiredStatus = [...isRequired];
    const status = "requiredStatus";
    if (inputList.length > 0) {
      inputList.map((x, index) => {
        if (
          x.status === true &&
          x.count === "" &&
          x.currency === "" &&
          x.price === "" &&
          x.transportType === "" &&
          x.unit === ""
        ) {
          listRequiredStatus[index][status] = false;
        } else {
          listRequiredStatus[index][status] = true;
        }
      });
    }
    setIsRequired(listRequiredStatus);
  }, [inputList]);

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    let name = "id";
    if (list[index][name] !== "") {
      name = "status";
      list[index][name] = false;
      setInputList(list);
    } else {
      list.splice(index, 1);
      setInputList(list);

      const listError = [...inputListError];
      listError.splice(index, 1);
      setInputListError(listError);

      const requiredStatus = [...isRequired];
      requiredStatus.splice(index, 1);
      setIsRequired(requiredStatus);
    }
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      {
        id: "",
        status: true,
        transportType: "",
        count: "",
        price: "",
        currency: mainCurrency,
        unit: "",
      },
    ]);
    setInputListError([
      ...inputListError,
      {
        transportTypeError: "",
        countError: "",
        priceError: "",
        currencyError: "",
        unitError: "",
      },
    ]);
    setIsRequired([
      ...isRequired,
      {
        requiredStatus: false,
      },
    ]);
  };

  return (
    <>
      <ContainerLabel htmlFor="container-meeting-summary">
        {t("WAREHOUSE_TRUCKS")}
      </ContainerLabel>
      {inputList.map((x, i) => {
        return (
          <React.Fragment key={"warehouse-truck-main-" + i}>
            {x.status && (
              <GridRow
                column="2rem 1fr 6rem 7rem 7rem 9rem"
                key={"warehouse-truck-" + i}
              >
                <Image
                  src={deleteIcon}
                  alt={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_REMOVE")}
                  title={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_REMOVE")}
                  onClick={() => handleRemoveClick(i)}
                  className="warehouse__delete-icon"
                />
                <div className="warehouse__dropdown">
                  <DropdownWithSearch
                    placeholder={t("TRANSPORT_TYPE")}
                    label={t("TRANSPORT_TYPE")}
                    value={x.transportType}
                    options={transportTypes}
                    required={isRequired[i]?.requiredStatus}
                    isMulti={false}
                    name="transportType"
                    error={inputListError[i].transportTypeError}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        i,
                        "transportType",
                        "transportTypeError"
                      )
                    }
                    labelStyles={
                      inputListError[i].transportTypeError !== ""
                        ? labelStylesError
                        : labelStyles
                    }
                    inputClass={
                      inputListError[i].transportTypeError !== ""
                        ? "dropdown-with-search__dropdown-input-error"
                        : "dropdown-with-search__dropdown-input"
                    }
                  />
                </div>
                <TextInput
                  type="text"
                  label={t("COUNT")}
                  name="count"
                  id="warehouse-count"
                  isFloat
                  value={String(x.count)}
                  onChange={(e) =>
                    handleInputChange(e, i, "count", "countError")
                  }
                  containerStyles={{ marginTop: "21px" }}
                  labelStyles={
                    inputListError[i].countError !== ""
                      ? labelStylesError
                      : labelStyles
                  }
                  inputStyles={
                    inputListError[i].countError !== ""
                      ? inputStylesError
                      : inputStyles
                  }
                  required={isRequired[i]?.requiredStatus}
                  error={inputListError[i].countError}
                  placeholder={t("COUNT")}
                />
                <TextInput
                  type="text"
                  label={t("PRICE")}
                  name="price"
                  id="warehouse-price"
                  isFloat
                  value={String(x.price)}
                  onChange={(e) =>
                    handleInputChange(e, i, "price", "priceError")
                  }
                  containerStyles={{ marginTop: "21px" }}
                  labelStyles={
                    inputListError[i].priceError !== ""
                      ? labelStylesError
                      : labelStyles
                  }
                  inputStyles={
                    inputListError[i].priceError !== ""
                      ? inputStylesError
                      : inputStyles
                  }
                  required={isRequired[i]?.requiredStatus}
                  error={inputListError[i].priceError}
                  placeholder={t("PRICE")}
                />
                <Dropdown
                  id="warehouse-currency"
                  label={t("GENERAL_CURRENCY")}
                  name="currency"
                  value={x.currency}
                  onChange={(e) =>
                    handleInputChange(e, i, "currency", "currencyError")
                  }
                  defaultOption={t("SELECT_CURRENCY")}
                  options={currencies}
                  labelStyles={
                    inputListError[i].currencyError !== ""
                      ? labelStylesError
                      : labelStyles
                  }
                  inputStyles={
                    inputListError[i].currencyError !== ""
                      ? inputStylesError
                      : inputStyles
                  }
                  required={isRequired[i]?.requiredStatus}
                  error={inputListError[i].currencyError}
                />
                <Dropdown
                  id="warehouse-unit"
                  label={t("UNIT")}
                  name="unit"
                  value={x.unit}
                  onChange={(e) => handleInputChange(e, i, "unit", "unitError")}
                  defaultOption={t("UNIT")}
                  options={updateUnitTranslation(unitList, t)}
                  labelStyles={
                    inputListError[i].unitError !== ""
                      ? labelStylesError
                      : labelStyles
                  }
                  inputStyles={
                    inputListError[i].unitError !== ""
                      ? inputStylesError
                      : inputStyles
                  }
                  required={isRequired[i]?.requiredStatus}
                  error={inputListError[i].unitError}
                />
              </GridRow>
            )}
          </React.Fragment>
        );
      })}
      <FilterFlexRow>
        <CreateButton
          onClick={handleAddClick}
          marginRight={inputList.length === 0 ? "0rem" : "3rem"}
        >{`${t("ADD_MORE")}`}</CreateButton>
      </FilterFlexRow>
    </>
  );
};

Trucks.propTypes = {
  t: PropTypes.func.isRequired,
  countryId: PropTypes.number,
  mainCurrency: PropTypes.number,
};
Trucks.defaultProps = {
  countryId: null,
  mainCurrency: null,
};

export default withTranslation()(Trucks);
